import React from 'react';
import styled from 'styled-components';

import { BG, FONT } from '../../styles/color';

const CounterWrapper = styled.div`
	display: flex;
	width: 120px;
	height: 45px;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 5px;
	background-color: ${BG.light01};
`;

const CounterButton = styled.button`
	background: transparent;
	width: 35px;
	height: 45px;
	padding: 0;
	margin: 0;
	border: none;
	cursor: pointer;
	pointer-events: ${ (props) => (props.$isActive ? 'auto' : 'none') };
	font: normal 350 28px Pretendard Variable;
	color: ${ (props) => (props.$isActive ? FONT.default : FONT.mid) };
`;

const CounterValue = styled.input`
	width: 40px;
	padding: 0;
	border: none;
	background-color: transparent;
	text-align: center;
	font: normal 500 18px Pretendard Variable;
	color: ${ FONT.default };

	&::-webkit-outer-spin-button,
  	&::-webkit-inner-spin-button {
    	-webkit-appearance: none;
    	margin: 0;
  	}
  
  	&[type=number] {
    	-moz-appearance: textfield;
  	}
`;

export default function Counter(props) {
	if(props.count <= 0) {
		props.setCountAs(1);
	}

	if(props.count >= 50) {
		props.setCountAs(49);
	}

	return (
		<CounterWrapper style={ props.style }>
			<CounterButton onClick={ props.onCountDown} $isActive={ props.isActive && props.count > 1 }>&ndash;</CounterButton>
			<CounterValue name="countValue" type="number" value={ props.count }
				onChange={ (e) => props.setCountAs(Number(e.target.value)) }
			/>
			<CounterButton onClick={ props.onCountUp } $isActive={ props.isActive && props.count < 49 }>+</CounterButton>
		</CounterWrapper>
  	);
}